function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 3.5v11h8v-11M8.5 12.5v-7M10.5 12.5v-7M6.5 12.5v-7M3.5 3.5h10M5.5 1.5h6",
  stroke: "#A0AFBE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgTrashGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}
export default SvgTrashGray;